import styled, { css } from 'styled-components'

export const ChecklistWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0 15px;
  border-bottom: 1px solid var(--t-checklist-wrapper-border);

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border: none;
  }
`

export const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ChecklistTitleWrap = styled.div`
  display: flex;
  gap: 32px;
  justify-content: space-between;
`

export const ChecklistItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ChecklistTitleContainer = styled.div`
  display: flex;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 809px;

  & label:not(:last-child) {
    margin: 0;
  }
`

export const TitleButtonWrap = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 3px;

  & button {
    height: 32px;
    padding: 0 8px;
    border-radius: 4px;

    svg {
      top: 0;
      margin-right: 0;
      width: 16px;
    }
  }
`

export const ChecklistTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
  white-space: normal;
  display: flex;
  align-items: center;
  color: var(--t-text-input);
`

export const ChecklistProgress = styled.div`
  display: flex;
  gap: 12px;
  height: 40px;
  align-items: center;
  flex: 0 0 auto;
`

export const ChecklistProgressBar = styled.div`
  height: 4px;
  background-color: var(--t-checklist-progress-bar-bg);
  position: relative;
  width: 240px;
  border-radius: 12px;

  &:after {
    content: '';
    position: absolute;
    height: 4px;
    min-width: 8px;
    transition: width 0.3s ease;
    ${({ bgColor }) => css`
      background-color: ${bgColor || 'var(--t-action-accent)'};
    `}

    border-radius: 12px;
    ${({ percent }) => css`
      width: ${percent || 0}%;
      max-width: 100%;
    `}
  }
`

export const ProgressCounter = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
`

export const ChecklistPointer = styled.div`
  min-width: 21px;
  text-align: center;
`

export const ChecklistButton = styled.div`
  max-width: 133px;

  button {
    padding: 0;
  }

  svg {
    margin-right: 8px;
  }
`
